<template>
<div
    class="outer_legal_container"
    v-if="data != null"
>
    <div
        class="cb_container"
    >
        <v-checkbox
            v-model="cb_value"
            v-on:change="onChangeCheckBox"
        />
    </div>
    <div
        class="label_container"
        v-on:click="onClickLabel"
    >
        <span
            v-for="(item, index) in data.segments"
            :key="'seg_'+index"
        >
            
            <a
                v-if="item.type == 'link'"
                @click.stop 
                :href="item.url"
                target="_blank"
            >{{item.text}}</a>
            <span
                v-else
            >
                {{item.text}}
            </span>
        </span>
    </div>
</div>
</template>

<script>
const _ = require('lodash');

export default {
    props: {
        type: {
            type: String,
            default: function() { return 'bulk-message-attestation'; }
        },

        organization_id: {
            type: String,
            default: function() { return null; }
        },

        organization_label: {
            type: String,
            default: function() { return null; }
        },

        override_patterns: {
            type: Array,
            default: function() { return null; }
        },
    },

    data() {
        return {
            cb_value: false,
            data: null,
        };
    },

    mounted () {
        this.cb_value = false;
        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/legal/get-agreement',
            
                'params' : {
                        'type': this.type,
                        'organization_id': this.organization_id,
                        'organization_label': this.organization_label,
                        'override_patterns': this.override_patterns,
                    },
            
                'on_success': (data) => {
                        this.data = data;
                    },
            
                'on_error': () => {
                    this.cb_value = false; // can't get the agreement text, can't have the box checked...
                },
            });
        },
        
        
        onClickLabel() 
        {
            this.cb_value = !this.cb_value;
            this.$emit('input',this.cb_value);
        },

        onChangeCheckBox()
        {
            this.$emit('input',this.cb_value);
        },

        getSpecimen()
        {
            return this.data.plain_text_specimen;
        },
    },

    watch: {
        organization_id(newValue, oldValue) {
            this.update();
        },

         organization_label(newValue, oldValue) {
            this.update();
        }
    },
}
</script>

<style lang="scss" scoped>
.outer_legal_container
{
    display: flex; 
    align-items: stretch;
}

.cb_container
{
    flex-grow: 0;
}

.label_container
{
    flex-grow: 1; 
    padding-top: 19px; 
    font-size: 16px;
    color: rgba(0,0,0,0.6);
    cursor: pointer;
}

</style>